import { pageModuleModel } from "app/models/store/page-module-model";

export class pageModuleMnemonic {
   static readonly type = '[pageModule] pageModule';

   constructor(public payload: pageModuleModel) {}
}